import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, renderSlot as _renderSlot, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import GateButton from "@/modules/action-points/components/GateButtonConfirmation.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'GateNegotiation',
  props: {
    value: null
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(GateButton, _mergeProps(_ctx.$attrs, {
        icon: _ctx.IconEnum.Handshake20Regular,
        color: _ctx.ColorEnum.Stone
      }), _createSlots({
        default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.value) + " ", 1)]),
        _: 2
      }, [_ctx.$slots.label ? {
        name: "label",
        fn: _withCtx(() => [_renderSlot(_ctx.$slots, "label")])
      } : undefined]), 1040, ["icon", "color"]);
    };
  }
});